module.exports = __webpack_public_path__ + "static/img/zysx.ae53ec8e.png";